import { useLog } from "~/lqs";
import { selectData } from "~/utils";
import { usePlayerParams } from "./use-player-params";

export function usePlayerLog() {
  const { logId } = usePlayerParams();

  return useLog(logId, { select: selectData });
}
